(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.pdf-view
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.tearsheet :as re-tearsheet]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.big-figure.pdf.view :as big-figures]
   [potpuri.core :as potpuri]))

(defn debt-financing-pages
  [report-data]
  (concat
   [(page/page
     (page/page-title
      {:fund-name (:fund-name report-data) :page-title "Debt financing" :toc-item true})
     (column/column [(table/dynamic-table-card "Debt financing, SEK"
                                               (-> report-data
                                                   :debt-financing
                                                   :portfolio-debt-financing)
                                               {:full-width? true
                                                :odd-color     (theme/color [:pdf :table :odd-color])
                                                :even-color    (theme/color [:pdf :table :even-color])
                                                :heading-color (theme/color [:pdf :table
                                                                             :heading-color])})
                     (card/card "Description"
                                (text-content/rich-content (-> report-data
                                                               :debt-financing
                                                               :debt-financing-text
                                                               :rich-content)))]))]))

(defn details-and-figures-pages
  [report-data]
  (let [page-title (page/page-title {:fund-name  (:fund-name report-data)
                                     :page-title "Details and figures"})]
    (concat
     (table/dynamic-table-pages
      {:fund-name (:fund-name report-data) :page-title "Details and figures" :toc-item true}
      "Current portfolio, SEK"
      (-> report-data
          :details-and-figures
          :current-portfolio)
      {:odd-color     (theme/color [:pdf :table :odd-color])
       :even-color    (theme/color [:pdf :table :even-color])
       :heading-color (theme/color [:pdf :table
                                    :heading-color])})
     (table/dynamic-table-pages
      page-title
      "Exited portfolio, SEK"
      (-> report-data
          :details-and-figures
          :exited-portfolio)
      {:odd-color     (theme/color [:pdf :table :odd-color])
       :even-color    (theme/color [:pdf :table :even-color])
       :heading-color (theme/color [:pdf :table
                                    :heading-color])})
     (table/dynamic-table-pages
      page-title
      "Investment summary, SEK"
      (-> report-data
          :details-and-figures
          :investment-summary)
      {:full-width?    true
       :hidden-columns #{"IQID"}
       :odd-color      (theme/color [:pdf :table :odd-color])
       :even-color     (theme/color [:pdf :table :even-color])
       :heading-color  (theme/color [:pdf :table
                                     :heading-color])})
     (table/dynamic-table-pages
      page-title
      "NAV Breakdown (IFRS), SEK"
      (-> report-data
          :details-and-figures
          :nav-breakdown-ifrs)
      {:odd-color     (theme/color [:pdf :table :odd-color])
       :even-color    (theme/color [:pdf :table :even-color])
       :heading-color (theme/color [:pdf :table
                                    :heading-color])})
     (table/dynamic-table-pages
      page-title
      "NAV Breakdown (INREV), SEK"
      (-> report-data
          :details-and-figures
          :nav-breakdown-inrev)
      {:odd-color     (theme/color [:pdf :table :odd-color])
       :even-color    (theme/color [:pdf :table :even-color])
       :heading-color (theme/color [:pdf :table
                                    :heading-color])}))))

(defn financial-statements-pages
  [report-data]
  (let [page-title {:fund-name (:fund-name report-data) :page-title "Financial statements"}]
    (concat
     (table/dynamic-table-pages
      {:fund-name (:fund-name report-data) :page-title "Financial statements" :toc-item true}
      "Consolidated statement of comprehensive income (INREV), SEK"
      (-> report-data
          :financial-statements
          :group-income-statement)
      {:odd-color     (theme/color [:pdf :table :odd-color])
       :even-color    (theme/color [:pdf :table :even-color])
       :heading-color (theme/color [:pdf :table
                                    :heading-color])})
     (table/dynamic-table-pages page-title
                                "Consolidated statement of financial position (INREV), SEK"
                                (-> report-data
                                    :financial-statements
                                    :statement-of-financial-position)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     (table/dynamic-table-pages page-title
                                "Consolidated statement of cash flows (INREV), SEK"
                                (-> report-data
                                    :financial-statements
                                    :cash-flow-statement)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])}))))

(defn overview-pages
  [report-data]
  (concat
   [(page/page
     (page/third-column-background)
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview" :toc-item true})
     (column/columns-2-to-1
      (card/card
       "Recent development"
       (text-content/rich-content (-> report-data
                                      :overview
                                      :recent-development-text
                                      :rich-content)))
      (card/card
       nil
       (big-figures/table (-> report-data
                              :overview
                              :overview-figures
                              :figures)
                          1
                          {:row-gap 12})
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :overview-figures)))))]
   (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Overview"}
                              "Fund figures (INREV)"
                              (-> report-data
                                  :overview
                                  :highlights)
                              {:odd-color     (theme/color [:pdf :table :odd-color])
                               :even-color    (theme/color [:pdf :table :even-color])
                               :heading-color (theme/color [:pdf :table
                                                            :heading-color])})
   [(page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
     (column/columns
      (card/card
       "Portfolio at fair value, MSEK"
       {:svg       (chart-view/chart-svg "highcharts"
                                         (potpuri/deep-merge (-> report-data
                                                                 :overview
                                                                 :portfolio-at-market-value
                                                                 :figures)
                                                             {:chart {:width  500
                                                                      :height 400}}))
        :width     350
        :alignment :center}
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :portfolio-at-market-value)))
      (card/card
       "GAV breakdown, MSEK (INREV)"
       {:svg       (chart-view/chart-svg "highcharts"
                                         (potpuri/deep-merge
                                          (-> report-data
                                              :overview
                                              :gav-breakdown
                                              :figures)
                                          {:chart {:width  500
                                                   :height 400}}))
        :width     350
        :alignment :center}
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :gav-breakdown)))))]))

(defn stockholm-living-pages
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(re-tearsheet/tearsheet-page-stockholm-living report-data)]
   (overview-pages report-data)
   (table/dynamic-table-pages
    {:fund-name (:fund-name report-data) :page-title "INREV NAV" :toc-item true}
    nil
    (-> report-data
        :inrev-nav)
    {:odd-color     (theme/color [:pdf :table :odd-color])
     :even-color    (theme/color [:pdf :table :even-color])
     :heading-color (theme/color [:pdf :table
                                  :heading-color])})
   (debt-financing-pages report-data)
   (details-and-figures-pages report-data)
   (financial-statements-pages report-data)))
